<template>
  <div class="line-box" :style="containerStyle">
    <div
      class="img-box"
      v-for="(img, idx) in imageList"
      :key="idx"
    >
      <el-image
        :src="img"
        :preview-src-list="imageList"
        :initial-index="idx"
        fit="contain"        lazy
        @error="handleImageError"
      >
        <!-- 加载中占位 -->
        <div slot="placeholder" class="img-placeholder">
          <i class="el-icon-loading"></i>
        </div>
        <!-- 加载失败占位 -->
        <div slot="error" class="img-error">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImageLine",
  props: {
    files: {
      type: Array,
      required: true
    },
    height: {
      type: [Number, String],
      default: 100
    }
  },
  data() {
    return {
      imageList: []
    };
  },
  computed: {
    containerStyle() {
      const h = this.height;
      return {
        height: typeof h === "number" ? `${h}px` : (h || "100px")
      };
    }
  },
  watch: {
    files: {
      immediate: true,
      handler(newVal) {
        this.imageList = newVal || [];
      }
    }
  },
  methods: {
    handleImageError(e) {
      // el-image 在 slot="error" 时会自动显示 fallback slot，这里仅作日志或处理备用逻辑
      console.warn("图片加载失败：", e);
    }
  }
};
</script>

<style lang="scss" scoped>
.line-box {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  flex-wrap: nowrap;
  overflow-x: auto;
  scrollbar-width: thin;
  scrollbar-color: #aaa transparent;
}

/* Chrome 滚动条 */
.line-box::-webkit-scrollbar {
  height: 6px;
}
.line-box::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}

.img-box {
  margin-right: 5px;
  flex-shrink: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

/* 让 el-image 占满父容器高度，宽度自适应 */
.img-box .el-image {
  height: 100%;
  width: auto;
  display: block;
  border-radius: 4px;
  overflow: hidden;
}

/* 占位与错误样式 */
.img-placeholder,
.img-error {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background: #f5f7fa;
  color: #c0c4cc;
  font-size: 20px;
}
</style>
